'use client';

import useSimpleApiHandler from '@frontend/jetlend-core/src/hooks/useSimpleApiHandler';
import { useMemo } from 'react';
import { mergeClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import styles from './InvestorsLiquidityDomTable.module.scss';
import InvestorsLiquidityDomTableRow from './InvestorsLiquidityDomTableRow';
import { ILiquidityDomRecord } from '@app/models/features/investors';
import { investorsJetLendStatisticsHandler } from '@app/ducks/investors/investors';

const getMaxAbsoluteCount = (records: ILiquidityDomRecord[]) => {
    const maxPositiveCount = records.reduce((acc, item) => item.count > 0 ? Math.max(acc, item.count) : acc, 0.0);

    const maxNegativeCount = records.reduce((acc, item) => item.count < 0 ? Math.max(acc, Math.abs(item.count)) : acc, 0.0);

    return Math.max(Math.abs(maxPositiveCount), Math.abs(maxNegativeCount));
};

const RECORDS: ILiquidityDomRecord[] = [
    {
        price: 1,
        ytm: 0.3125,
        count: 447,
    },
    {
        price: 0.9999,
        ytm: 0.3126,
        count: 157,
    },
    {
        price: 0.9996,
        ytm: 0.3129,
        count: 201,
    },
    {
        price: 0.9995,
        ytm: 0.3130,
        count: 289,
    },
    {
        price: 0.9993,
        ytm: 0.3132,
        count: -208,
    },
    {
        price: 0.9990,
        ytm: 0.3135,
        count: -142,
    },
    {
        price: 0.9988,
        ytm: 0.3137,
        count: -110,
    },
    {
        price: 0.9987,
        ytm: 0.3138,
        count: -89,
    },
];

/**
 * Отображение примерного стакана вторичного рынка.
 */
export default function InvestorsLiquidityDomTable() {
    const [ publicStats ] = useSimpleApiHandler(investorsJetLendStatisticsHandler);

    // Захардкодили для задачи
    // https://jetlend.monday.com/boards/9427577392/pulses/9448763895
    const records: ILiquidityDomRecord[] = RECORDS; // publicStats?.order_book

    const maxCount = useMemo(() => getMaxAbsoluteCount(records ?? []), [ records ]);

    return (
        <table className={styles['table']}>
            <thead>
                <tr>
                    <th className={mergeClassNames(['h-ta-left', styles['title']])}>Заявки на покупку</th>
                    <th className={mergeClassNames(['h-ta-center', styles['title']])}>Цена/Ставка</th>
                    <th className={mergeClassNames(['h-ta-right', styles['title']])}>Заявки на продажу</th>
                </tr>
            </thead>
            <tbody>
                {records?.map(item => (
                    <InvestorsLiquidityDomTableRow
                        key={item.price}
                        item={item}
                        maxCount={maxCount}
                    />
                ))}
            </tbody>
        </table>
    );
};
